import { render } from "./ProductDraggableSearch.vue?vue&type=template&id=1d3773d6&scoped=true"
import script from "./ProductDraggableSearch.vue?vue&type=script&lang=js"
export * from "./ProductDraggableSearch.vue?vue&type=script&lang=js"

import "./ProductDraggableSearch.vue?vue&type=style&index=0&id=1d3773d6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3773d6"],['__file',"src/components/ProductDraggableSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d3773d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d3773d6', __exports__)) {
    api.reload('1d3773d6', __exports__)
  }
  
  module.hot.accept("./ProductDraggableSearch.vue?vue&type=template&id=1d3773d6&scoped=true", () => {
    api.rerender('1d3773d6', render)
  })

}


export default __exports__